import React from "react";
import Avatar from "react-avatar";

const UserProfile = ({ username, userImage }) => {
  const UserProfile = userImage === undefined || null ? "" : userImage;
  const image = process.env.REACT_APP_USER_IMAGE_PATH + UserProfile;
  return (
    <>
      {UserProfile ? (
        <>
          <img
            className="rounded"
            src={image}
            alt=""
            srcSet={image}
            width="30"
            height="30"
          />
        </>
      ) : (
        <>
          <Avatar
            className="rounded"
            name={username}
            maxInitials={2}
            size={30}
            round="100px"
          />
        </>
      )}
    </>
  );
};

export default UserProfile;
